import { FC } from 'react';
import { motion } from 'framer-motion';
import { Image as ImageComponent } from '@city-sage/aurum-avis-labs-components';

interface LocationCardProps {
  location: string;
  itineraryCount: number;
  onClick?: () => void;
  mode: 'country' | 'city';
  countryImageUrl?: string | null;
}

export const LocationCard: FC<LocationCardProps> = ({ 
  location, 
  itineraryCount, 
  onClick,
  mode,
  countryImageUrl
}) => {
  return (
    <motion.div
      className="flex-shrink-0 overflow-hidden rounded-xl"
    >
      <motion.div
        className="w-32 aspect-[2/3] rounded-xl overflow-hidden relative cursor-pointer transition-all duration-300"
        whileHover={{ scale: 1.02 }}
        whileTap={{ scale: 0.98 }}
        onClick={onClick}
      >
      {/* Background Image */}
      {countryImageUrl ? (
        <ImageComponent
          src={countryImageUrl}
          alt={location}
          className="absolute inset-0 rounded-xl"
          imageClassName="w-full h-full object-cover rounded-xl"
        />
      ) : (
        <div className="absolute inset-0 bg-gradient-to-br from-blue-400 to-purple-600 rounded-xl" />
      )}

      {/* Overlay */}
      <div className="absolute inset-0 rounded-xl bg-gradient-to-b from-black/10 via-black/5 to-black/10" />

      {/* Content */}
      <div className="absolute bottom-0 left-0 right-0 p-3 bg-gradient-to-t from-black/60 to-transparent">
        <h3 className="text-white font-semibold text-sm mb-1 truncate">{location}</h3>
        <p className="text-white/90 text-xs  truncate">
          {itineraryCount} {itineraryCount === 1 ? 'itinerary' : 'itineraries'}
        </p>
      </div>
      </motion.div>
    </motion.div>
  );
}; 